import { Component, h, Prop, Element } from '@stencil/core';
import { setDataAttributesOnFormFields } from '../component-utils/formUtils';
import { getClassListString } from '../component-utils/stencilUtils';

@Component({
  tag: 'aafp-button',
  shadow: false,
})
export class AafpButton {
  @Prop({ reflect: false }) actionId!: string;
  @Prop({ reflect: false, mutable: true }) type: 'button' | 'submit' | 'reset' = 'button';
  @Prop({ reflect: false }) name!: string;
  @Prop({ reflect: false }) value!: string;
  @Prop({ reflect: false }) ariaLabel: string | null;
  @Prop({ mutable: true }) isDisabled?: true | false = false;
  @Prop({ mutable: true }) buttonClass: 'primary' | 'secondary' | 'tertiary' = 'primary';
  /**
   * Changes the location of the caret icon (only impacts tertiary buttons)
   */
  @Prop() iconLocation: 'left' | 'right' = 'right';
  /**
   * For passing error classes from jqueryval
   */
  @Prop({ mutable: true }) additionalClasses: Object = {};
  /**
   * For adding data-attributes to form inputs. Must be in "data-name=value|data-message=Test Message" format.
   */
  @Prop() dataAttr: string;
  @Element() buttonEl: HTMLElement;

  componentWillLoad() {}
  componentDidLoad() {
    const buttonElement: HTMLElement | null = this.buttonEl.querySelector('button');
    if (this.dataAttr && buttonElement) {
      setDataAttributesOnFormFields(buttonElement, this.dataAttr);
    }
  }
  render() {
    const styleClasses = this.additionalClasses;
    return (
      <button
        class={getClassListString(
          { 'button-back': this.iconLocation === 'left' },
          `adl-button__link adl-button__link--${this.buttonClass}`,
        )}
        type={this.type}
        id={this.actionId}
        aria-label={this.ariaLabel}
        value={this.value}
        name={this.name}
        disabled={this.isDisabled}
        data-content={this.value}
        {...styleClasses}
      >
        <span class="adl-button__link-text">{this.value}</span>
      </button>
    );
  }
}
